import {useState} from "react";
import styled from "styled-components";
import {Switch} from "ui/base/switch/Switch";
import {defaultThemeColors, fonts, mediaSizes} from "ui/theme";
import {PrevButton} from "ui/base/Button/EmblaButtons";

const NotificationSection = ({setTabToNull}) => {
    const [notifications, setNotifications] = useState({
        receiveMessage: true,
        newClassRequest: true,
        clientCancelClass: true,
        rescheduleClassRequest: true,
        supportRequests: true,
        newItemsOffers: true,
    });

    return (
        <Container>
            <HeaderTitleContainer>
                <PrevButton onClick={setTabToNull}/>
                <HeaderTitle>Edit profile</HeaderTitle>
            </HeaderTitleContainer>
            <Section>
                <Title>User Notification</Title>
                <ToggleRow>
                    <Label>Receiving a message</Label>

                    <Switch
                        id="recieved_msg"
                        toggled={notifications.receiveMessage}
                        onChange={() =>
                            setNotifications((prev) => ({
                                ...prev,
                                receiveMessage: !prev.receiveMessage,
                            }))
                        }
                    />
                </ToggleRow>

                <ToggleRow>
                    <Label>Class request accepted by instructor</Label>

                    <Switch
                        id="new_class_request"
                        toggled={notifications.newClassRequest}
                        onChange={() =>
                            setNotifications((prev) => ({
                                ...prev,
                                newClassRequest: !prev.newClassRequest,
                            }))
                        }
                    />
                </ToggleRow>

                <ToggleRow>
                    <Label>Instructor cancels an upcoming class</Label>

                    <Switch
                        id="client_cancel_class"
                        toggled={notifications.clientCancelClass}
                        onChange={() =>
                            setNotifications((prev) => ({
                                ...prev,
                                clientCancelClass: !prev.clientCancelClass,
                            }))
                        }
                    />
                </ToggleRow>

                <ToggleRow>
                    <Label>Re-schedule request accepted</Label>

                    <Switch
                        id="reschedule_class_request"
                        toggled={notifications.rescheduleClassRequest}
                        onChange={() =>
                            setNotifications((prev) => ({
                                ...prev,
                                rescheduleClassRequest: !prev.rescheduleClassRequest,
                            }))
                        }
                    />
                </ToggleRow>
            </Section>

            {/*<Section>*/}
            {/*    <Title>{"Teache Notification"}</Title>*/}
            {/*    <ToggleRow>*/}
            {/*        <Label>Support Requests</Label>*/}

            {/*        <Switch*/}
            {/*            id={"support_requests"}*/}
            {/*            toggled={notifications.supportRequests}*/}
            {/*            onChange={() =>*/}
            {/*                setNotifications((prev) => ({*/}
            {/*                    ...prev,*/}
            {/*                    supportRequests: !prev.supportRequests,*/}
            {/*                }))*/}
            {/*            }*/}
            {/*        />*/}
            {/*    </ToggleRow>*/}

            {/*    <ToggleRow>*/}
            {/*        <Label>New items and offers </Label>*/}

            {/*        <Switch*/}
            {/*            id={"new_items_offers"}*/}
            {/*            toggled={notifications.newItemsOffers}*/}
            {/*            onChange={() =>*/}
            {/*                setNotifications((prev) => ({*/}
            {/*                    ...prev,*/}
            {/*                    newItemsOffers: !prev.newItemsOffers,*/}
            {/*                }))*/}
            {/*            }*/}
            {/*        />*/}
            {/*    </ToggleRow>*/}
            {/*</Section>*/}
        </Container>
    );
};

const Container = styled.div`
    padding: 0.8rem;
    width: 100%;
    display: grid;
    max-width: 900px;
    margin-inline: auto;
    gap: 1rem;
    font-family: var(--font-secondary);
    @media (width >= ${mediaSizes.md}) {
        padding: 1rem;
    }
`;

const Section = styled.div`
    margin-bottom: 1rem;
`;

const ToggleRow = styled.div`
    display: flex;
    justify-items: center;
    align-items: center;
    text-align: center;
    justify-content: space-between;
    margin-bottom: 1rem;
    padding: 1em;
    border-radius: 6px;
    margin-top: 1rem;
    border: 2px solid ${defaultThemeColors.lightBlue};
`;

const Title = styled.h3`
    margin-bottom: 1rem;
    font-size: ${fonts.sizes.medium};
    font-weight: 600;

    @media (width >= ${mediaSizes.md}) {
        font-size: ${fonts.sizes.big};
    }
`;

const Label = styled.label`
    font-weight: 500;
`;

const HeaderTitleContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 1.2rem;
    margin-bottom: 1.8rem;
    @media (width >= ${mediaSizes.md}) {
        display: none;
    }
`

const HeaderTitle = styled.div`
    font-size: ${fonts.sizes.big};
    font-weight: 600;

    @media (width >= ${mediaSizes.md}) {
        font-size: ${fonts.sizes.h4};
    }
    @media (width >= ${mediaSizes.lg}) {
        font-size: ${fonts.sizes["h3.4"]};
    }
`

export {NotificationSection};
